import { IRootState } from '../../../store'
import { IObstetricsOptionsState } from '../store/options.types'

export const getObstetricsptionsSelector = (state: IRootState): IObstetricsOptionsState =>
  state.options.obstetricsOptions
